import React from "react";
import { FlightTags } from "~/components/flight/sections/FlightTags.jsx";
import { $t } from "~/i18n.js";
import { parseMinutes } from "~/lib/localize.js";
import { DateTimeFormat } from "../date/DateTimeFormat.jsx";
import { Tag } from "antd";
import { FlightOpenIcon } from "./sections/flightOpenIcon.jsx";
import { EyeOutlined } from "@ant-design/icons";

export const FlightDatum = () => ({
  title: $t("Datum"),
  dataIndex: "datum",
  render: (text) => (
    <DateTimeFormat
      date={text}
      options={{ month: "short", day: "2-digit", year: "2-digit" }}
    />
  ),
});

export const FlightKist = () => ({
  title: $t("Kist"),
  render: (_, flight) => {
    return (
      <span>
        {flight.callsign}: {flight.type}
      </span>
    );
  },
});

export const FlightRol = (pilot) => ({
  title: $t("Rol"),
  render: (_, flight) => {
    if (flight.gezagvoerder_id == pilot.id)
      return <Tag color="blue">{$t("PIC")}</Tag>;
    if (flight.tweede_inzittende_id == pilot.id && flight.is_fis)
      return <Tag color="green">{$t("Instructie")}</Tag>;
    return <Tag>{$t("Pax")}</Tag>;
  },
});

export const FlightMethode = () => ({
  title: $t("Meth."),
  dataIndex: "start_methode",
  render: (text) => $t(text),
});

export const FlightDuur = () => ({
  title: $t("Vluchtduur"),
  dataIndex: "vluchtduur",
  render: (text, flight) => (
    <div>
      {flight.starts > 1 && (
        <span>
          {flight.starts} {$t("starts")},{" "}
        </span>
      )}
      <span>{parseMinutes(text)}</span>
    </div>
  ),
});

export const FlightTagsColumn = (pilot, props = {}) => ({
  render: (_, flight) => (
    <FlightTags flight={flight} pilot={pilot} {...props} />
  ),
});

export const FlightBijzonderheden = () => ({
  title: $t("Aantekeningen"),
  dataIndex: "bijzonderheden",
  render: (text) => (
    <p>
      {text !== "" ? (
        <span>{text}</span>
      ) : (
        <span className="gray">{$t("Geen")}</span>
      )}
    </p>
  ),
});

export const OpenFlightColumn = () => ({
  render: (_, flight) => (
    <FlightOpenIcon flight_object={flight} icon={<EyeOutlined />} buttonProps={{type: 'primary'}} />
  ),
});